import React from 'react';
import './MobileHome.css';

const MobileHome = () => {
  const handleButtonClick = () => {
    window.location.href = "https://thecleanier.com/building";
  };

  return (
    <div className='mobileContainer'>
      <img src='/mobileLogo.png' className='mobile-logo' alt='Mobile Logo' />
      <img src='/mobileEmpty.png' className='mobile-empty-image' alt='Mobile Empty Image' />
      <div className='mobile-label'>
        모바일 기기로 접속이 불가합니다.<br/>
        서비스 이용을 원하실 경우<br/>
        PC 환경에서 접속 부탁드립니다.
      </div>
      <button
        className='back-to-cleanier-button'
        onClick={handleButtonClick}
      >
        홈으로 바로가기
      </button>
      {/* <img src="/mobile.png" className='mobileImage' alt="Mobile Home"/> */}
    </div>
  );
};

export default MobileHome;
